import { useMemo } from "react";
import { TableContext } from "../../../../../../../../components/Table/context";
import { useAccess } from "../../../../../../../../utils/hooks/access";
import { useDateIdMap } from "../../../../../../components/TimeSheetTable/hooks/useDateIdMap";
import { useDateTimesheetMap } from "../../../../../../components/TimeSheetTable/hooks/useDateTimesheetMap";
import { useTimeSheetTable } from "../../../../../../components/TimeSheetTable/hooks/useTable";
import Table from "../../../../../../components/TimeSheetTable/index";
import { useColumns } from "../../../../../../components/TimeSheetTable/useColumns";

function TimeSheetTablePreview({ user, data }) {
    const dateIdMap = useDateIdMap({ data });
    const dateTimesheetMap = useDateTimesheetMap({ data });
    const { hasAccess: canViewRates } = useAccess("canViewRates");
    const columns = useColumns({
        user,
        canCreate: false,
        canEdit: false,
        dateIdMap,
        dateTimesheetMap,
        canViewRates,
    });
    const filteredColumns = useMemo(() => {
        return columns
            .slice(0, columns.length - 1)
            .map((column) => ({
                ...column,
                disableSortBy: true,
            }));
    }, [columns]);
    const table = useTimeSheetTable({
        hasURLBindedFilters: false,
        user,
        columns: filteredColumns,
        data,
        dateIdMap,
        // payGroupItem,
    });

    return (
        <TableContext.Provider value={table}>
            <Table />
        </TableContext.Provider>
    );
}

export default TimeSheetTablePreview;
